import type Image from "next/image";

export type NextImageCandidate = typeof Image & { default?: NextImageCandidate; };

export function resolveNextImage(candidate: NextImageCandidate): typeof Image {
    if (candidate.default) {
        return resolveNextImage(candidate.default);
    }
    return candidate;
}
